import printTestReportService from "./printTestReportService";

const testReportService = [
    ...printTestReportService
];

export { testReportService as default, printTestReportService }